import { useFeatureVisibility } from '@nextgen-web-framework/all';

export const useFeatureFlag = () => {
  const hidePromotionBannerFlag = useFeatureVisibility?.('cart.enable.hide.promotionbanner') ?? false;
  const hideBVFlag = useFeatureVisibility?.('purchase.enable.hide.bv') ?? false;
  const cartOverrideFlag = useFeatureVisibility?.('cart.cartoverride') ?? true;
  const cartSelectionFlag = useFeatureVisibility?.('purchase.cartselection') ?? false;
  const showSOPSingleItemFlag = useFeatureVisibility?.('cart.enable.show.sopsingleitem') ?? false;
  const showAuxiliaryToggleFlag = useFeatureVisibility?.('cart.enable.show.auxiliaryToggle') ?? false;
  const showRecommendedProductsFlag = useFeatureVisibility?.('cart.enable.show.recommendedProducts') ?? false;
  const showEditLabelFlag = useFeatureVisibility?.('cart.enable.show.editLabel') ?? false;
  return {
    hidePromotionBannerFlag,
    hideBVFlag,
    cartOverrideFlag,
    cartSelectionFlag,
    showSOPSingleItemFlag,
    showAuxiliaryToggleFlag,
    showEditLabelFlag,
    showRecommendedProductsFlag,
  };
};
